// Metakaolin grades and their technical properties.
// VALUES ARE ILLUSTRATIVE / MOCK for demonstration of the download area.

export const DL_TEXT = {
  de: {
    subtitle: 'Datenblatt',
    property: 'Kennwert',
    downloadSheet: 'Datenblatt (.txt)',
    downloadCsv: 'Werte (.csv)',
    dosage: 'Empfohlene Dosierung',
    appearance: 'Erscheinung',
    note: 'Hinweis: Die angegebenen Werte sind typische, illustrative Richtwerte (MOCK) zur Veranschaulichung. Verbindliche Datenblätter erhalten Sie direkt von der Newchem GmbH.',
    tableTitle: 'Übersicht der Kennwerte',
    grade: 'Qualität',
  },
  en: {
    subtitle: 'Data sheet',
    property: 'Property',
    downloadSheet: 'Data sheet (.txt)',
    downloadCsv: 'Values (.csv)',
    dosage: 'Recommended dosage',
    appearance: 'Appearance',
    note: 'Note: The stated values are typical, illustrative reference values (MOCK) for demonstration. Binding data sheets are available directly from Newchem GmbH.',
    tableTitle: 'Overview of key values',
    grade: 'Grade',
  },
};

// Property definitions (ordered) with bilingual labels and units.
export const PROPERTIES = [
  { key: 'chapelle', unit: 'mg Ca(OH)₂/g', de: 'Chapelle-Wert (Kalkbindung)', en: 'Chapelle value (lime binding)' },
  { key: 'bet', unit: 'm²/g', de: 'BET-Oberfläche', en: 'BET specific surface' },
  { key: 'sio2', unit: '%', de: 'SiO₂-Gehalt', en: 'SiO₂ content' },
  { key: 'al2o3', unit: '%', de: 'Al₂O₃-Gehalt', en: 'Al₂O₃ content' },
  { key: 'whiteness', unit: 'L*', de: 'Weißgrad', en: 'Whiteness' },
  { key: 'd50', unit: 'µm', de: 'Mittlere Korngröße (D50)', en: 'Mean particle size (D50)' },
];

export const GRADES = [
  {
    id: 'mk-standard',
    name: 'Newchem MK Standard',
    de: { tag: 'Universelle Qualität', appearance: 'Cremeweißes Pulver', dosage: '8–15 % Zementersatz', desc: 'Ausgewogene, wirtschaftliche Qualität für allgemeine Beton- und Mörtelanwendungen.' },
    en: { tag: 'Universal grade', appearance: 'Cream-white powder', dosage: '8–15% cement replacement', desc: 'Balanced, economical grade for general concrete and mortar applications.' },
    values: { chapelle: 900, bet: 15, sio2: 52, al2o3: 42, whiteness: 78, d50: 6.0 },
  },
  {
    id: 'mk-premium',
    name: 'Newchem MK Premium',
    de: { tag: 'Hohe Reaktivität', appearance: 'Hellbeiges Pulver', dosage: '10–20 % Zementersatz', desc: 'Besonders reaktive Qualität mit hohem Kalkbindevermögen für anspruchsvolle Dauerhaftigkeit.' },
    en: { tag: 'High reactivity', appearance: 'Light beige powder', dosage: '10–20% cement replacement', desc: 'Highly reactive grade with strong lime-binding capacity for demanding durability.' },
    values: { chapelle: 1150, bet: 22, sio2: 54, al2o3: 43, whiteness: 82, d50: 4.5 },
  },
  {
    id: 'mk-white',
    name: 'Newchem MK White',
    de: { tag: 'Maximaler Weißgrad', appearance: 'Reinweißes Pulver', dosage: '8–18 % Zementersatz', desc: 'Für weißen Sicht- und Architekturbeton mit brillanter, gleichmäßiger Optik.' },
    en: { tag: 'Maximum whiteness', appearance: 'Pure white powder', dosage: '8–18% cement replacement', desc: 'For white fair-faced and architectural concrete with a brilliant, uniform appearance.' },
    values: { chapelle: 1050, bet: 19, sio2: 53, al2o3: 44, whiteness: 92, d50: 4.0 },
  },
  {
    id: 'mk-lime',
    name: 'Newchem MK Lime',
    de: { tag: 'Für Kalksysteme', appearance: 'Cremeweißes Pulver', dosage: '10–25 % vom Bindemittel', desc: 'Optimiert für historische und reine Kalkmörtel – verträglich mit dem Originalbestand.' },
    en: { tag: 'For lime systems', appearance: 'Cream-white powder', dosage: '10–25% of the binder', desc: 'Optimised for historical and pure lime mortars – compatible with the original substance.' },
    values: { chapelle: 1000, bet: 18, sio2: 51, al2o3: 41, whiteness: 80, d50: 5.5 },
  },
];
